import React from 'react';
import { isPreviewMode } from '../../services/previewMode';
import styles from './PreviewBanner.module.css';

/**
 * Marks the page as an Umbraco draft preview.
 *
 * Inside the backoffice preview frame Umbraco shows its own "Preview Mode" bar, but the
 * frame's "open website" button and the redirect's own URL both open a plain tab with no such
 * hint — and a page showing unpublished content with nothing to say so reads as a bug.
 */
export const PreviewBanner: React.FC = () => {
  if (!isPreviewMode()) {
    return null;
  }

  return (
    <div className={styles.previewBanner} role="status">
      Podgląd wersji roboczej — te zmiany nie są jeszcze opublikowane.
    </div>
  );
};
